<script>
import CharityManagementMixin from "./inc/CharityManagementMixin";
import '../assets/css/charity.css'

export default {
  name: "GfCharity",
  mixins: [CharityManagementMixin],

	methods: {
		stage(beneficiary) {
			var callBackValue = {
				beneficiaryId: beneficiary.BeneficiaryAccountId,
				beneficiaryName: beneficiary.BeneficiaryName,
				beneficiaryImagePath: beneficiary.BeneficiaryImagePath,
				beneficiaryTags: beneficiary.BeneficiaryTags
			};
			this.selectedCharity.beneficiary = beneficiary;
			this.selectedCharity.beneficiaryId = beneficiary.BeneficiaryAccountId;
			this.selectedCharity.beneficiaryImagePath = beneficiary.BeneficiaryImagePath;
			this.selectedCharity.beneficiaryName = beneficiary.BeneficiaryName;
			this.selectedCharity.tags = beneficiary.BeneficiaryTags;
			if (this.afterSelectCallBack && this.afterSelectCallBack !== "")
				window[this.afterSelectCallBack](callBackValue);
			this.$emit('selected',callBackValue)
			this.loadList();
		},

		$_charityManagementMixin_stageCharity (beneficiary) {
			this.$gfLogger.logInfo(beneficiary);
			this.availableTiers = [];

			return this.stage(beneficiary);
		}
	},
};
</script>